
const configurator = (module, apiUrl = null) => {
  const getApiUrl = () => {
    if (!apiUrl) {
      throw new Error('No API URL provided');
    }
    return apiUrl;
  };
  const getLsKey = () => {
    return `${module}-filters`;
  };
  return {getLsKey, getApiUrl};
};
export {configurator};
